import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
// utils
import { isValidToken, setSession } from 'utils/jwt';
import { PATH_DASHBOARD } from 'routes/paths';

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  product: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user, product } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
      product,
    };
  },
  LOGIN: (state, action) => {
    const { user, _id } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      _id,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    wallet: null,
    product: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      wallet: null,
      product: null,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
  reinitialize: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const token = window.localStorage.getItem('token');
        const userID = window.localStorage.getItem('userID');

        if (token && isValidToken(token) && userID) {
          setSession(token);
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              isInitialized: true,
              user: null,
            },
          });
          // axios
          //   .get(`/user/profile`)
          //   .then(({ data }) => {
          //     localStorage.setItem('user', JSON.stringify(data.result.user));
          //     dispatch({
          //       type: 'INITIALIZE',
          //       payload: {
          //         isAuthenticated: true,
          //         isInitialized: true,
          //         user: data.result.user,
          //       },
          //     });
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
              wallet: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
            wallet: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (userID, password) => {
    const response = await axios.post('/auth/login', {
      userID,
      password,
    });
    const { jwtToken: token, user } = response.data;
    console.log(response.data);
    window.localStorage.setItem('userID', user._id);
    window.location.replace(PATH_DASHBOARD.request.list);
    setSession(token);
    dispatch({
      type: 'LOGIN',
      payload: {
        user,
      },
    });
  };

  const reinitialize = async () => {
    const response = await axios.get('user/profile');
    const { user, wallet, product } = response.data;
    dispatch({
      type: 'LOGIN',
      payload: {
        user,
        wallet,
        product,
      },
    });
  };

  const register = async (email, password, firstName, lastName) => {
    const response = await axios.post('/user/register', {
      email,
      password,
      firstName,
      lastName,
      gender: 'male',
      nation: 'Iran',
      nationalCode: '1231231231',
      level: 0,
    });
    const { login } = response.data;

    window.localStorage.setItem('token', login.token);
    dispatch({
      type: 'REGISTER',
      payload: {
        user: {
          firstName,
          lastName,
          email,
        },
      },
    });
  };

  const logout = async () => {
    setSession(null);
    localStorage.removeItem('token');
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
        reinitialize,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
